/**
 * オブジェクトをディープコピーします。循環参照も考慮します。
 * 注意: 特殊なオブジェクトやクラスのインスタンスなど、特定のオブジェクトには対応していません。
 *
 * @param {*} target - ディープコピーするオブジェクト。
 * @param {Map} [map=new Map()] - 既にコピーされたオブジェクトをトラッキングするためのMap。
 * @returns {*} - コピーされた新しいオブジェクト、またはプリミティブ値。
 *
 * @example
 * const originalObj = { a: 1, b: { c: 2 } };
 * const copiedObj = mtapp.deepCopy(originalObj);
 */
export function deepCopy(target, map = new Map()) {
    if (target === null || typeof target !== 'object') return target;

    if (map.get(target)) {
        return map.get(target);
    }

    const isArray = Array.isArray(target);
    const cloneTarget = isArray ? [] : {};

    map.set(target, cloneTarget);

    if (isArray) {
        target.forEach((item, index) => {
            cloneTarget[index] = deepCopy(item, map);
        });
    } else {
        Object.keys(target).forEach((key) => {
            cloneTarget[key] = deepCopy(target[key], map);
        });
    }

    return cloneTarget;
}
